import { graphql } from 'relay-runtime';

export const KUDOS_SUMMARY_QUERY = graphql`
  query KudosSummaryQuery($username: String, $internalId: String) {
    unified {
      unifiedProfile(
        unifiedProfileUsername: $username
        internalId: $internalId
      ) {
        ... on UnifiedProfile {
          gamification {
            ... on UnifiedGamification {
              levels {
                ... on UnifiedGamificationLevel {
                  id
                  currentLevelArt
                  currentLevelDescription
                  currentLevelName
                  currentPoints
                  maxPoints
                  nextLevelName
                }
              }
              recognitionsSummary {
                ... on UnifiedGamificationRecognitionsSummary {
                  id
                  totals {
                    comment
                    count
                  }
                }
              }
            }
          }
        }
        ... on UnifiedQueryError {
          identifier
          message
          extensions {
            errorType
            statusCode
          }
        }
      }
    }
  }
`;
